import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const PrivacyPolicy = () => {
    const { t } = useTranslation();

    return (
        <div style={{
            fontFamily: 'Arial, sans-serif',
            lineHeight: 1.6,
            maxWidth: '800px',
            margin: '0 auto',
            padding: '20px',
            backgroundColor: '#f5f5f5',
            minHeight: '100vh'
        }}>
            <div style={{
                background: 'white',
                padding: '30px',
                borderRadius: '10px',
                boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
            }}>
                <h1 style={{
                    color: '#333',
                    borderBottom: '2px solid #667eea',
                    paddingBottom: '10px'
                }}>
                    {t('privacyPolicy.title')}
                </h1>

                <p>
                    <strong>{t('privacyPolicy.lastUpdated')}</strong> {t('privacyPolicy.date')}
                </p>

                <h2 style={{ color: '#555', marginTop: '30px' }}>
                    {t('privacyPolicy.sections.general.title')}
                </h2>
                <p>{t('privacyPolicy.sections.general.content')}</p>

                <h2 style={{ color: '#555', marginTop: '30px' }}>
                    {t('privacyPolicy.sections.dataCollection.title')}
                </h2>
                <p>{t('privacyPolicy.sections.dataCollection.intro')}</p>
                <ul>
                    <li>{t('privacyPolicy.sections.dataCollection.items.contact')}</li>
                    <li>{t('privacyPolicy.sections.dataCollection.items.technical')}</li>
                    <li>{t('privacyPolicy.sections.dataCollection.items.cookies')}</li>
                </ul>

                <h2 style={{ color: '#555', marginTop: '30px' }}>
                    {t('privacyPolicy.sections.dataUsage.title')}
                </h2>
                <p>{t('privacyPolicy.sections.dataUsage.intro')}</p>
                <ul>
                    <li>{t('privacyPolicy.sections.dataUsage.items.forms')}</li>
                    <li>{t('privacyPolicy.sections.dataUsage.items.consultation')}</li>
                    <li>{t('privacyPolicy.sections.dataUsage.items.improvement')}</li>
                    <li>{t('privacyPolicy.sections.dataUsage.items.analytics')}</li>
                </ul>

                <h2 style={{ color: '#555', marginTop: '30px' }}>
                    {t('privacyPolicy.sections.cookies.title')}
                </h2>
                <p>{t('privacyPolicy.sections.cookies.intro')}</p>
                <ul>
                    <li>{t('privacyPolicy.sections.cookies.items.experience')}</li>
                    <li>{t('privacyPolicy.sections.cookies.items.analysis')}</li>
                    <li>{t('privacyPolicy.sections.cookies.items.settings')}</li>
                </ul>
                <p>{t('privacyPolicy.sections.cookies.note')}</p>

                <h2 style={{ color: '#555', marginTop: '30px' }}>
                    {t('privacyPolicy.sections.security.title')}
                </h2>
                <p>{t('privacyPolicy.sections.security.content')}</p>

                <h2 style={{ color: '#555', marginTop: '30px' }}>
                    {t('privacyPolicy.sections.rights.title')}
                </h2>
                <p>{t('privacyPolicy.sections.rights.intro')}</p>
                <ul>
                    <li>{t('privacyPolicy.sections.rights.items.know')}</li>
                    <li>{t('privacyPolicy.sections.rights.items.access')}</li>
                    <li>{t('privacyPolicy.sections.rights.items.correct')}</li>
                    <li>{t('privacyPolicy.sections.rights.items.withdraw')}</li>
                </ul>

                <h2 style={{ color: '#555', marginTop: '30px' }}>
                    {t('privacyPolicy.sections.contact.title')}
                </h2>
                <p>{t('privacyPolicy.sections.contact.intro')}</p>
                <ul>
                    <li><strong>{t('privacyPolicy.sections.contact.email')}</strong> alex@ignite-web.com</li>
                    <li><strong>{t('privacyPolicy.sections.contact.phone')}</strong> +370 XXX XXXXX</li>
                </ul>

                <h2 style={{ color: '#555', marginTop: '30px' }}>
                    {t('privacyPolicy.sections.changes.title')}
                </h2>
                <p>{t('privacyPolicy.sections.changes.content')}</p>

                <Link
                    to="/"
                    style={{
                        display: 'inline-block',
                        marginTop: '30px',
                        padding: '10px 20px',
                        background: '#667eea',
                        color: 'white',
                        textDecoration: 'none',
                        borderRadius: '5px'
                    }}
                >
                    {t('privacyPolicy.backButton')}
                </Link>
            </div>
        </div>
    );
};

export default PrivacyPolicy;